import React from 'react';
import BoardList from './BoardList';

export default function EventList() {
  return (
    <BoardList
      fixedType="event"
      showTabs={false}
      title="이벤트"
      subtitle="진행 중인 이벤트를 확인해 주세요."
      basePath="/event"
    />
  );
}
